import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-turns-form-dashboard',
  templateUrl: './turns-form-dashboard.component.html',
  styleUrls: ['./turns-form-dashboard.component.scss']
})
export class TurnsFormDashboardComponent implements OnInit, OnDestroy {

  form;
  desks;
  existingSchedules;
  accessListKeys;
  selectedTabIndex = 0;
  getFormInfoSubscription: Subscription;
  refreshFormSubscription: Subscription;
  getFormDesksSubscription: Subscription;
  getFormAccessListKeysSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private formsTurnsService: FormsTurnsService,
              private snackbarService: SnackBarService,
              private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.selectedTabIndex = this.activatedRoute.snapshot.queryParams['tab'] === 'turns' ? 1 : 0;
    this.setBreadcrumb();
    this.getFormInfo();
    this.getFormAccessListKeys();
    this.refreshFormSubscription = this.formsTurnsService.refreshFormListen().subscribe(
      (res) => {
        this.getFormInfo();
        this.getFormAccessListKeys();
      }
    );
  }

  private getFormInfo() {
    const internalId = this.activatedRoute.snapshot.params['formid'];
    this.getFormInfoSubscription = this.formsTurnsService.getFormInfo(internalId).subscribe(
      (res) => {
        this.form = res;
        this.getFormExistingSchedules();
        this.getFormDesks();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }
  private getFormDesks() {
    this.getFormDesksSubscription = this.formsTurnsService.getFormDesks(this.form.CenterInternalId).subscribe(
      (res) => {
        this.desks = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }
  private getFormAccessListKeys() {
    const internalId = this.activatedRoute.snapshot.params['formid'];
    this.getFormAccessListKeysSubscription = this.formsTurnsService.getFormAccessListKeys(internalId).subscribe(
      (res) => {
        this.accessListKeys = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getFormExistingSchedules() {
    this.formsTurnsService.getFormExistingSchedules(this.form.CenterInternalId).pipe(
      tap(o => this.existingSchedules = o)
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-file-alt', 'turns-page.form detail', '/turns/forms', [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.forms', '/turns/forms'), new BRoute('turns-page.form detail')]));
  }

  ngOnDestroy() {
    if (this.getFormInfoSubscription) { this.getFormInfoSubscription.unsubscribe(); }
    if (this.refreshFormSubscription) { this.refreshFormSubscription.unsubscribe(); }
    if (this.getFormDesksSubscription) { this.getFormDesksSubscription.unsubscribe(); }
    if (this.getFormAccessListKeysSubscription) { this.getFormAccessListKeysSubscription.unsubscribe(); }
  }
}
